/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Tag_Term_LabelInputs */



/**
* | output |
* | --- |
* | "Tag Term" |
*
* @param {Tags_Manager_Tag_Term_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_tag_term_label = /** @type {((inputs?: Tags_Manager_Tag_Term_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Tag_Term_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terme du tag")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag-Begriff")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termine tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Термин-тег")
	if (locale === "es") return /** @type {LocalizedString} */ ("Término de etiqueta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグ用語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग शब्द")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Termo de etiqueta")
	return /** @type {LocalizedString} */ ("Tag Term")
});